export const advStaticObj = {
  "8858192a-4707-404c-bbeb-7691be7ac227": {
    followers: {
      fb: "@triproriginal 1.3K followers",
      ins: "@triprindia 17.4K followers",
    },
    CIRecom: {
      "Single Image": {
        budget_allocation_perc: 5,
      },
      "Single Video": { budget_allocation_perc: 5 },
      Carousel: {
        budget_allocation_perc: 15,
      },
      Collection: {},
      "Dynamic Product Ad (DPA)": {
        budget_allocation_perc: 24,
      },
    },
    CC: {
      1: "https://d25vr4g4asm46a.cloudfront.net/media/tripr_1.jpg",
      2: "https://d25vr4g4asm46a.cloudfront.net/media/tripr_2.jpg",
      3: "https://d25vr4g4asm46a.cloudfront.net/media/tripr_3.jpg",
      4: "https://d25vr4g4asm46a.cloudfront.net/media/tripr_4.jpg",
      5: "https://d25vr4g4asm46a.cloudfront.net/media/tripr_5.mp4",
      6: "https://d25vr4g4asm46a.cloudfront.net/media/tripr_6.jpg",
    },
  },

  "b3861ef5-56e2-4ffe-b662-ccd3803a152d": {
    followers: {
      fb: "@amaha.health 74.4K followers",
      ins: "@amaha.health 14.9K followers",
    },
    CIRecom: {
      "Single Image": {
        budget_allocation_perc: 5,
      },
      "Single Video": { budget_allocation_perc: 5 },
      Carousel: {},
      Collection: {},
      "Dynamic Product Ad (DPA)": {},
    },
    CC: {
      1: "https://d25vr4g4asm46a.cloudfront.net/media/amaha_1.jpg",
      2: "https://d25vr4g4asm46a.cloudfront.net/media/amaha_2.jpg",
      3: "https://d25vr4g4asm46a.cloudfront.net/media/amaha_3.mp4",
      4: "https://d25vr4g4asm46a.cloudfront.net/media/amaha_4.mp4",
      5: "https://d25vr4g4asm46a.cloudfront.net/media/amaha_5.mp4",
      6: "https://d25vr4g4asm46a.cloudfront.net/media/amaha_6.mp4",
    },
  },
  "3fd1933a-ebf1-4ac5-a24c-73b39904c2bc": {
    followers: {
      fb: "@amaha.health 74.4K followers",
      ins: "@amaha.health 14.9K followers",
    },
    CIRecom: {
      "Single Image": {
        budget_allocation_perc: 5,
      },
      "Single Video": { budget_allocation_perc: 5 },
      Carousel: {},
      Collection: {},
      "Dynamic Product Ad (DPA)": {},
    },
    CC: {
      1: "https://d25vr4g4asm46a.cloudfront.net/media/amaha_1.jpg",
      2: "https://d25vr4g4asm46a.cloudfront.net/media/amaha_2.jpg",
      3: "https://d25vr4g4asm46a.cloudfront.net/media/amaha_3.mp4",
      4: "https://d25vr4g4asm46a.cloudfront.net/media/amaha_4.mp4",
      5: "https://d25vr4g4asm46a.cloudfront.net/media/amaha_5.mp4",
      6: "https://d25vr4g4asm46a.cloudfront.net/media/amaha_6.mp4",
    },
  },
  "e9ead51d-cafa-423c-8ef3-c6f8fe906f4a": {
    followers: {
      fb: "@Smileneo 5.5K followers",
      ins: "@Smileneo 12.9k followers",
    },
    CIRecom: {
      "Single Image": {
        budget_allocation_perc: 5,
      },
      "Single Video": { budget_allocation_perc: -5 },
      Carousel: {
        budget_allocation_perc: 15,
      },
      Collection: {},
      "Dynamic Product Ad (DPA)": {
        budget_allocation_perc: 24,
      },
    },
    CC: {
      1: "https://d25vr4g4asm46a.cloudfront.net/media/1737697844558_473803127_581726481385627_6762830439352305238_n.jpg",
      2: "https://d25vr4g4asm46a.cloudfront.net/media/1737697975533_470820197_2284245655264454_8852825881210855987_n.jpg",
      3: "https://d25vr4g4asm46a.cloudfront.net/media/1737698092588_473923976_583877847870216_7852320189999209099_n.jpg",
      4: "https://d25vr4g4asm46a.cloudfront.net/media/1737698451322_AdLibrary(3).mp4",
      5: "https://d25vr4g4asm46a.cloudfront.net/media/1737698483509_AdLibrary(2).mp4",
      6: "https://d25vr4g4asm46a.cloudfront.net/media/1737698509108_AdLibrary(1).mp4",
    },
    creativeInsights: {
      high: [
        {
          ad_format: "Video",
          ad_name: "FB_PR_KSA_DCIX3_Sep_24_Video_Arabic",
          url: "https://d25vr4g4asm46a.cloudfront.net/media/1737698621975_AdExperiencePreview.mp4",
          ctr: 0.84,
          conversion: 554,
          spends: 8476.88,
          weightage: 17.032389001748182,
        },
        {
          ad_format: "Video",
          ad_name: "FB_PR_KSA_Zainab_Aug_24_Video_Arabic_IOS",
          url: "https://d25vr4g4asm46a.cloudfront.net/media/1737698705071_AdExperiencePreview(1).mp4",
          ctr: 1.21,
          conversion: 187,
          spends: 3553.65,
          weightage: 12.756009984084965,
        },
        {
          ad_format: "Video",
          ad_name:
            "FB_PR_KSA_Hana_Meme_Tiktok_Oct_24_Video_Arabic_Open_Audience_IOS",
          url: "https://d25vr4g4asm46a.cloudfront.net/media/1737698781214_AdExperiencePreview(2).mp4",
          ctr: 0.76,
          conversion: 130,
          spends: 2289.55,
          weightage: 11.912272914196649,
        },
      ],
      low: [
        {
          ad_format: "Video",
          ad_name: "FB_PR_KSA_Omran_Oct_24_Video_Arabic_IOS",
          url: "https://d25vr4g4asm46a.cloudfront.net/media/1737698841598_AdExperiencePreview(3).mp4",
          ctr: 0.19,
          conversion: 0,
          spends: 10.63,
          weightage: -0.00333459274233297,
        },
        {
          ad_format: "Video",
          ad_name: "Alina_Film3_May_24_English_UAE_IOS_Combined_Audience",
          url: "https://d25vr4g4asm46a.cloudfront.net/media/1737698889358_AdExperiencePreview(4).mp4",
          ctr: 0.22,
          conversion: 0,
          spends: 57.91,
          weightage: -0.005666329119618976,
        },
        {
          ad_format: "Video",
          ad_name: "Alina_Film4_May_24_English_UAE_IOS_LookaLike",
          url: "https://d25vr4g4asm46a.cloudfront.net/media/1737698999407_AdExperiencePreview(6).mp4",
          ctr: 0.08,
          conversion: 0,
          spends: 17.84,
          weightage: -0.040862943462859846,
        },
      ],
    },
  },
  "04c7403d-6e62-447b-8f72-b99388cdc972": {
    followers: {
      fb: "@fnpuae 24.1K followers",
      ins: "@fnp.ae 32.4K followers",
    },
    CIRecom: {
      "Single Image": {
        budget_allocation_perc: -12,
      },
      "Single Video": { budget_allocation_perc: -7 },
      Carousel: {
        budget_allocation_perc: 15,
      },
      Collection: {},
      "Dynamic Product Ad (DPA)": {
        budget_allocation_perc: 24,
      },
    },
    CC: {
      1: "https://d25vr4g4asm46a.cloudfront.net/media/fnp_1.png",
      2: "https://d25vr4g4asm46a.cloudfront.net/media/fnp_2.png",
      3: "https://d25vr4g4asm46a.cloudfront.net/media/fnp_3.png",
      4: "https://d25vr4g4asm46a.cloudfront.net/media/ad_final_1738221636056.png",
      5: "https://d25vr4g4asm46a.cloudfront.net/media/ad_final_1738221685083.png",
      6: "https://d25vr4g4asm46a.cloudfront.net/media/ad_final_1738221707315.png",
    },

    creativeInsights: {
      high: [
        {
          ad_format: "Image",
          ad_name: "Birthday_cakes",
          url: "https://d25vr4g4asm46a.cloudfront.net/media/1739950748597_image(3).png",
          ctr: 0.25,
          conversion: 1668,
          spends: 30642.48,
          weightage: 44.95671609731243,
        },
        {
          ad_format: "Image",
          ad_name: "fathers_day",
          url: "https://d25vr4g4asm46a.cloudfront.net/media/1739950790377_image(4).png",
          video: null,
          ctr: 0.17,
          conversion: 724,
          spends: 22991.18,
          weightage: 22.428724457586643,
        },
        {
          ad_format: "Image",
          ad_name: "fresh_flowers",
          url: "https://d25vr4g4asm46a.cloudfront.net/media/1739950834102_image(5).png",
          video: null,
          ctr: 0.21,
          conversion: 626,
          spends: 16154.95,
          weightage: 21.097379539557515,
        },
      ],
      low: [
        {
          ad_format: "Image",
          ad_name: "one_hour_anniversary_gifts",
          url: "https://d25vr4g4asm46a.cloudfront.net/media/1739952453326_image(9).png",
          video: null,
          ctr: 0.45,
          conversion: 0,
          spends: 18.71,
          weightage: -0.9864383230887657,
        },
        {
          ad_format: "Image",
          ad_name: "birthday_flowers",
          url: "https://d25vr4g4asm46a.cloudfront.net/media/1739952489716_image(10).png",
          video: null,
          ctr: 0.45,
          conversion: 0,
          spends: 54.48,
          weightage: -1.0194913205033347,
        },
        {
          ad_format: "Image",
          ad_name: "For_husband",
          url: "https://d25vr4g4asm46a.cloudfront.net/media/1739952521984_image(11).png",
          video: null,
          ctr: 1.0,
          conversion: 0,
          spends: 36.15,
          weightage: -1.3829638093609715,
        },
      ],
    },
  },
  "6d8cc8e8-29ea-4b41-8001-b86b896859dd": {
    followers: {
      fb: "@ReneeCosmetics 104.6K followers",
      ins: "@reneeofficial 635K followers",
    },
    creativeInsights: {
      high: [
        {
          ad_format: "Video",
          ad_name: "priyanka prime matte – Copy",
          url: "https://d25vr4g4asm46a.cloudfront.net/media/1741619478981_ReneCosmetics-productbrandFacebook.mp4",
          ctr: 1.37,
          conversion: 248,
          spends: 80288.38,
          weightage: 44.95671609731243,
        },
        {
          ad_format: "Video",
          ad_name: "LumiGlow_ Edwina – Copy",
          url: "https://d25vr4g4asm46a.cloudfront.net/media/1741619643279_ReneCosmetics-productbrandFacebook(1).mp4",
          video: null,
          ctr: 1.03,
          conversion: 518,
          spends: 119306.26,
          weightage: 22.428724457586643,
        },
        {
          ad_format: "Video",
          ad_name: "stay forerver",
          url: "https://d25vr4g4asm46a.cloudfront.net/media/1741619710620_ReneCosmetics-productbrandFacebook(2).mp4",
          video: null,
          ctr: 1.04,
          conversion: 386,
          spends: 109415.23,
          weightage: 21.097379539557515,
        },
      ],
      low: [
        {
          ad_format: "Video",
          ad_name: "Glass Sunscreen_Neelima",
          url: "https://d25vr4g4asm46a.cloudfront.net/media/1741619835761_ReneCosmetics-productbrandFacebook(3).mp4",
          video: null,
          ctr: 0.83,
          conversion: 1,
          spends: 582.96,
          weightage: -0.9864383230887657,
        },
        {
          ad_format: "Video",
          ad_name: "Prime matte Vaani",
          url: "https://d25vr4g4asm46a.cloudfront.net/media/1741619967336_ReneCosmetics-productbrandFacebook(5).mp4",
          video: null,
          ctr: 0.98,
          conversion: 20,
          spends: 8604.76,
          weightage: -1.0194913205033347,
        },
        {
          ad_format: "Video",
          ad_name: "Coverup_Ankita Version 2 – Copy 2",
          url: "https://d25vr4g4asm46a.cloudfront.net/media/1741619889809_ReneCosmetics-productbrandFacebook(4).mp4",
          video: null,
          ctr: 0.69,
          conversion: 25,
          spends: 10291.71,
          weightage: -1.3829638093609715,
        },
      ],
    },
  },
  "2cabd63d-c7fe-4803-a84f-b682dceefb33": {
    followers: {
      fb: "@freecultr 406.6K followers",
      ins: "@freecultr 17.5K followers",
    },
  },
  "004beea7-d608-4834-a1c7-f5b710ca9474": {
    compCreative: [
      {
        page_id: "5699478389",
        page_name: "Custom Ink",
        data: [
          {
            live_date: "2025-04-04",
            platform: [
              "facebook",
              "instagram",
              "audience_network",
              "messenger",
            ],
            url: "https://d25vr4g4asm46a.cloudfront.net/media/Capture.JPG",
          },
          {
            live_date: "2025-04-01",
            platform: [
              "facebook",
              "instagram",
              "audience_network",
              "messenger",
            ],
            url: "https://d25vr4g4asm46a.cloudfront.net/media/Capture2.jpg",
          },
          {
            live_date: "2025-04-02",
            platform: [
              "facebook",
              "instagram",
              "audience_network",
              "messenger",
            ],
            url: "https://d25vr4g4asm46a.cloudfront.net/media/custom_link_3.png",
          },
        ],
      },
      {
        page_id: "361496300388338",
        page_name: "Hopicustom",
        data: [
          {
            live_date: "2025-04-10",
            platform: [
              "facebook",
              "instagram",
              "audience_network",
              "messenger",
            ],
            url: "https://d25vr4g4asm46a.cloudfront.net/media/Capture2.1.jpg",
          },
          {
            live_date: "2025-04-02",
            platform: [
              "facebook",
              "instagram",
              "audience_network",
              "messenger",
            ],
            url: "https://d25vr4g4asm46a.cloudfront.net/media/Capture_h2.jpg",
          },
          {
            live_date: "2025-04-07",
            platform: [
              "facebook",
              "instagram",
              "audience_network",
              "messenger",
            ],
            url: "https://d25vr4g4asm46a.cloudfront.net/media/hopicustom_3.png",
          },
        ],
      },
    ],
  },
  "f5516c43-ce9a-47d6-9956-27d6e6d07660": {
    compCreative: [
      {
        page_id: "5699478389",
        page_name: "Venum",
        data: [
          {
            live_date: "2025-04-05",
            platform: [
              "facebook",
              "instagram",
              "audience_network",
              "messenger",
            ],
            url: "https://d25vr4g4asm46a.cloudfront.net/media/Capture_b1.jpg",
          },
          {
            live_date: "2025-04-01",
            platform: [
              "facebook",
              "instagram",
              "audience_network",
              "messenger",
            ],
            url: "https://d25vr4g4asm46a.cloudfront.net/media/Capture_b2.jpg",
          },
          {
            live_date: "2025-04-04",
            platform: [
              "facebook",
              "instagram",
              "audience_network",
              "messenger",
            ],
            url: "https://d25vr4g4asm46a.cloudfront.net/media/venum_3.png",
          },
        ],
      },
      {
        page_id: "361496300388338",
        page_name: "Hayabusa Fight",
        data: [
          {
            live_date: "2025-04-04",
            platform: [
              "facebook",
              "instagram",
              "audience_network",
              "messenger",
            ],
            url: "https://d25vr4g4asm46a.cloudfront.net/media/Capture_b3.jpg",
          },
          {
            live_date: "2025-04-14",
            platform: [
              "facebook",
              "instagram",
              "audience_network",
              "messenger",
            ],
            url: "https://d25vr4g4asm46a.cloudfront.net/media/Capture_b4.jpg",
          },
          {
            live_date: "2025-04-11",
            platform: [
              "facebook",
              "instagram",
              "audience_network",
              "messenger",
            ],
            url: "https://d25vr4g4asm46a.cloudfront.net/media/hayabusa_3.png",
          },
        ],
      },
    ],
  },
  "ad0e9b42-00b4-41c7-9ae4-bc613df1c677": {
    compCreative: [
      {
        page_id: "5699478389",
        page_name: "Aurate New York",
        data: [
          {
            live_date: "2025-04-01",
            platform: [
              "facebook",
              "instagram",
              "audience_network",
              "messenger",
            ],
            url: "https://d25vr4g4asm46a.cloudfront.net/media/A-a.jpg",
          },
          {
            live_date: "2025-04-05",
            platform: [
              "facebook",
              "instagram",
              "audience_network",
              "messenger",
            ],
            url: "https://d25vr4g4asm46a.cloudfront.net/media/A-b-1.jpg",
          },
          {
            live_date: "2025-04-02",
            platform: [
              "facebook",
              "instagram",
              "audience_network",
              "messenger",
            ],
            url: "https://d25vr4g4asm46a.cloudfront.net/media/A-c-1.jpg",
          },
        ],
      },
      {
        page_id: "361496300388338",
        page_name: "Mejuri",
        data: [
          {
            live_date: "2025-04-04",
            platform: [
              "facebook",
              "instagram",
              "audience_network",
              "messenger",
            ],
            url: "https://d25vr4g4asm46a.cloudfront.net/media/M-a.jpg",
          },
          {
            live_date: "2025-04-07",
            platform: [
              "facebook",
              "instagram",
              "audience_network",
              "messenger",
            ],
            url: "https://d25vr4g4asm46a.cloudfront.net/media/M-b.jpg",
          },
          {
            live_date: "2025-04-09",
            platform: [
              "facebook",
              "instagram",
              "audience_network",
              "messenger",
            ],
            url: "https://d25vr4g4asm46a.cloudfront.net/media/M-c.jpg",
          },
        ],
      },
    ],
  },
  "b716bad6-3bef-43cb-9e46-14de718a6868": {
    compCreative: [
      {
        page_id: "5699478389",
        page_name: "Sugar Cosmetics",
        data: [
          {
            live_date: "2025-04-01",
            platform: [
              "facebook",
              "instagram",
              "audience_network",
              "messenger",
            ],
            url: "https://d25vr4g4asm46a.cloudfront.net/media/Sugar1.jpg",
          },
          {
            live_date: "2025-04-05",
            platform: [
              "facebook",
              "instagram",
              "audience_network",
              "messenger",
            ],
            url: "https://d25vr4g4asm46a.cloudfront.net/media/Sugar2.jpg",
          },
          {
            live_date: "2025-04-02",
            platform: [
              "facebook",
              "instagram",
              "audience_network",
              "messenger",
            ],
            url: "https://d25vr4g4asm46a.cloudfront.net/media/Sugar3.jpg",
          },
        ],
      },
      {
        page_id: "361496300388338",
        page_name: "Maybelline New York",
        data: [
          {
            live_date: "2025-04-04",
            platform: [
              "facebook",
              "instagram",
              "audience_network",
              "messenger",
            ],
            url: "https://d25vr4g4asm46a.cloudfront.net/media/MB1.jpg",
          },
          {
            live_date: "2025-04-07",
            platform: [
              "facebook",
              "instagram",
              "audience_network",
              "messenger",
            ],
            url: "https://d25vr4g4asm46a.cloudfront.net/media/MB2.jpg",
          },
          {
            live_date: "2025-04-09",
            platform: [
              "facebook",
              "instagram",
              "audience_network",
              "messenger",
            ],
            url: "https://d25vr4g4asm46a.cloudfront.net/media/MB3.jpg",
          },
        ],
      },
    ],
  },
  "d70c297a-558d-40f1-9360-8d4a5c175a92": {
    compCreative: [
      {
        page_id: "5699478389",
        page_name: "Durex",
        data: [
          {
            live_date: "2025-05-04",
            platform: [
              "facebook",
              "instagram",
              "audience_network",
              "messenger",
            ],
            url: "https://d25vr4g4asm46a.cloudfront.net/media/Durex1.jpg",
          },
          {
            live_date: "2025-05-03",
            platform: [
              "facebook",
              "instagram",
              "audience_network",
              "messenger",
            ],
            url: "https://d25vr4g4asm46a.cloudfront.net/media/Durex2.jpg",
          },
          {
            live_date: "2025-05-01",
            platform: [
              "facebook",
              "instagram",
              "audience_network",
              "messenger",
            ],
            url: "https://d25vr4g4asm46a.cloudfront.net/media/Durex3.jpg",
          },
        ],
      },
      {
        page_id: "361496300388338",
        page_name: "Kindly",
        data: [
          {
            live_date: "2025-05-02",
            platform: [
              "facebook",
              "instagram",
              "audience_network",
              "messenger",
            ],
            url: "https://d25vr4g4asm46a.cloudfront.net/media/Kindly1.jpg",
          },
          {
            live_date: "2025-05-05",
            platform: [
              "facebook",
              "instagram",
              "audience_network",
              "messenger",
            ],
            url: "https://d25vr4g4asm46a.cloudfront.net/media/Kindly2.jpg",
          },
          {
            live_date: "2025-05-02",
            platform: [
              "facebook",
              "instagram",
              "audience_network",
              "messenger",
            ],
            url: "https://d25vr4g4asm46a.cloudfront.net/media/Kindly3.jpg",
          },
        ],
      },
    ],
  },
  // "b1a57bdb-d415-4669-b062-566f26939630": {
  //   compCreative: [
  //     {
  //       page_id: "569947838",
  //       page_name: "Staze9to9",
  //       data: [
  //         {
  //           live_date: "2025-06-16",
  //           platform: [
  //             "facebook",
  //             "instagram",
  //             "audience_network",
  //             "messenger",
  //           ],
  //           url: "https://d25vr4g4asm46a.cloudfront.net/media/1750149306549_Screenshot2025-06-17140001.jpg",
  //         },
  //         {
  //           live_date: "2025-06-14",
  //           platform: [
  //             "facebook",
  //             "instagram",
  //             "audience_network",
  //             "messenger",
  //           ],
  //           url: "https://d25vr4g4asm46a.cloudfront.net/media/1750149306577_Screenshot2025-06-17140105.jpg",
  //         },
  //         {
  //           live_date: "2025-06-16",
  //           platform: [
  //             "facebook",
  //             "instagram",
  //             "audience_network",
  //             "messenger",
  //           ],
  //           url: "https://d25vr4g4asm46a.cloudfront.net/media/1750149306594_Screenshot2025-06-17140334.jpg",
  //         },
  //       ],
  //     },
  //     {
  //       page_id: "36149630038833",
  //       page_name: "Recode Studios",
  //       data: [
  //         {
  //           live_date: "2025-06-16",
  //           platform: [
  //             "facebook",
  //             "instagram",
  //             "audience_network",
  //             "messenger",
  //           ],
  //           url: "https://d25vr4g4asm46a.cloudfront.net/media/1750149800318_Screenshot2025-06-17141201.jpg",
  //         },
  //         {
  //           live_date: "2025-06-14",
  //           platform: [
  //             "facebook",
  //             "instagram",
  //             "audience_network",
  //             "messenger",
  //           ],
  //           url: "https://d25vr4g4asm46a.cloudfront.net/media/1750149800354_Screenshot2025-06-17141257.jpg",
  //         },
  //         {
  //           live_date: "2024-10-09",
  //           platform: [
  //             "facebook",
  //             "instagram",
  //             "audience_network",
  //             "messenger",
  //           ],
  //           url: "https://d25vr4g4asm46a.cloudfront.net/media/1750149800364_Screenshot2025-06-17140825.jpg",
  //         },
  //       ],
  //     },
  //   ],
  // },
};
